import React, { useState } from 'react';
import { RDS } from 'ouisys-engine/strategy';
import { Button, Link, defineMessages } from 'ouisys-component-library';
import { PINEntryFailure, PINEntrySuccess, backToStartAction, usePinFlowState } from 'ouisys-engine/pinFlow';
import Loader from '../Loader/index';
import ThankYouStep from '../ThankYouStep';
import { FormattedMessage, injectIntl } from '../../localization';
import { useRootContext } from '../../providers/RootContext';
import { useDispatch } from '../../__doNotModify/store';
import { useSelector } from 'react-redux';

const defaultMessages = defineMessages({
  pinInput: {
    id: 'pinInput',
    defaultMessage: 'PIN'
  }
});

interface CustomProps {
  rds: RDS.RemoteDataState<PINEntryFailure, PINEntrySuccess>;
  onEnd: (pin: string) => void;
}
type PINEntryStepProps = CustomProps & {
  intl: any;
};

const serviceLogo = require('../../assets/imgs/logo.png');
const gameIcon = require('../../assets/imgs/game-icon.png');
const magicIcon = require('../../assets/imgs/magic-wand.png');
const PINEntryStep = (props: PINEntryStepProps) => {
  const { intl } = props;
  const pinFlowState = usePinFlowState(useSelector);
  const { pinMaxLength, operator } = pinFlowState?.data;
  const { msisdn } = useRootContext();
  const dispatch = useDispatch();

  const [pin, setPin] = useState<string>('');

  const backToStart = () => dispatch(backToStartAction());

  const pinLength = operator === 'IQ_ZAIN' ? 5 : 4;

  return (
    <form
      onSubmit={(ev) => {
        ev.preventDefault();
        props.onEnd(pin);
      }}
    >
      {RDS.WhenSuccess<PINEntrySuccess, JSX.Element>(
        <>
          <div className="service-icons">
            <img src={gameIcon} alt="Game" />
            <img src={magicIcon} alt="Magic" />
          </div>
          <img src={serviceLogo} className="service-logo" />

          <div className="label-pin">
            <FormattedMessage
              id="pinLabel"
              defaultMessage="Enter the PIN sent to your mobile numer via SMS to proceed"
            />
          </div>
          <div className="pin-input">
            <div className="pin"></div>
            <input
              className="text-input"
              type="text"
              placeholder={intl.formatMessage(defaultMessages.pinInput)}
              value={pin}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength={pinLength}
              minLength={pinLength}
              autoComplete="one-time-code"
              onChange={(ev) => setPin(ev.target.value)}
            />
          </div>
          <Button
            id="AFsubmitbtn"
            type="submit"
            className="btn"
            disabled={RDS.IsLoading(props.rds) || pin.length < pinLength}
          >
            <FormattedMessage id="pinButton" defaultMessage="Confirm" />
          </Button>
          <div className="service-description">
            <img src={gameIcon} alt="Game" />
            <h5>
              <FormattedMessage
                id="serviceDescription"
                defaultMessage="Subscribe now to 7ME service to get HTML5 Games"
              />
            </h5>
          </div>
        </>,
        ({ finalUrl, isAlreadySubscribed }) => (
          <ThankYouStep finalUrl={finalUrl} isAlreadySubscribed={isAlreadySubscribed} />
        )
      )(props.rds)}

      {RDS.match<PINEntryFailure, PINEntrySuccess, any>({
        failure: (err: PINEntryFailure) => (
          <div className="error-msg">
            <FormattedMessage id={err.errorType} />
          </div>
        ),
        nothingYet: () => (
          <Link className="link-try-again" id="backToStart" onClick={backToStart}>
            <FormattedMessage
              id="tryAgain"
              defaultMessage="Try again"
              values={{
                phone: msisdn
              }}
            />
          </Link>
        ),
        loading: () => <Loader />,
        success: ({ finalUrl }) => null
      })(props.rds)}
    </form>
  );
};

export default injectIntl(PINEntryStep);
